import GenericGridCreator from 'ps-components/AdvancedTable/GenericGrid/GenericGridCreator';
import { SurveyDetails } from './SurveyDetails';

const AI_MATCHING_PAGINATE = 'AI_MATCHING_PAGINATE'
const AI_MATCHING_TOGGLE_SIMILARITY = 'AI_MATCHING_SHOW_SIMILARITY'
const similarityField = 'field_search_similarity'

const newGenericGrid = new GenericGridCreator(
  'AI_MATCHING',
  {},
  {
    addedFilters: [],
    defaultLeftColumns: [
      {
        Header: 'Survey Job Matches',
        stickyLeft: true,
        customRender: SurveyDetails,
        width: 350,
        accessor: null
      }
    ],
    hiddenTerms: ['field_survey_code', 'field_job_code', 'field_job_scope', 'field_pub_survey_long_name', similarityField]
  },
  {
    getInstanceState: (store: any) => store.landingPage.InternalJobsReducer.surveyLibraryGrid
  },
  true
);

export const aiMatchingGridActions = newGenericGrid.getActions();

aiMatchingGridActions.paginate = (limit: number, offset: number) => {
  return (dispatch: any) => {
    return dispatch({
      type: AI_MATCHING_PAGINATE,
      payload: { limit, offset }
    });
  };
};

aiMatchingGridActions.toggleSimilarityDisplay = () => {
  return (dispatch: any) => {
    return dispatch({
      type: AI_MATCHING_TOGGLE_SIMILARITY
    });
  };
};

function extendReducer(state: any, action: any) {
  switch (action.type) {
    case AI_MATCHING_PAGINATE:
      return { ...state, metadata: { ...state.metadata, offset: action.payload.offset, limit: action.payload.limit } };
    case AI_MATCHING_TOGGLE_SIMILARITY:
      const updatedColumns = state.tableProps?.columnHeaders?.map((c: any) => {
        if (c?.id === similarityField) {
          return { ...c, show: !c.show }
        }
        return c
      })
      
      const updatedHiddenColumns = state.tableProps.hiddenColumns.includes(similarityField) ? 
        state.tableProps.hiddenColumns.filter((c: string) => c !== similarityField) :
        [...state.tableProps.hiddenColumns, similarityField]

      return {
        ...state,
        tableProps: {
          ...state.tableProps,
          hiddenColumns: updatedHiddenColumns,
          columnHeaders: updatedColumns 
        } 
      }
    default:
      return null;
  }
}

export default newGenericGrid.createReducer(extendReducer);
